module.exports = __webpack_public_path__ + "img/exitoseleccion.5afaee02.png";